@defer (hydrate on timer(10000)) {
  @if (showChat) {
  <app-chat-window></app-chat-window>
  }
}
<footer [dir]="languageService.dir()">
  <div class="content-wrapper">
    <ion-row>
      <ion-col size="12" size-lg="4" class="">
        <div class="logo">
          <ion-img src="./assets/satel-logo-en.svg" alt="Satel | Properties in Riyadh"></ion-img>
          <span>{{ 'footer.plan_together' | translate }}</span>
        </div>
        <form [formGroup]="subscribeForm" (submit)="subscribe()">
          <div class="subscribe-wrapper">
            <p>{{ 'footer.subscribe_as' | translate }}</p>
            <div class="message" [class.error]="isError" [class.success]="isSuccess">{{message}}</div>
            <div class="s_w">
              <ion-segment formControlName="type" value="b2c">
                <ion-segment-button value="b2c">{{ 'footer.tenant' | translate }}</ion-segment-button>
                <ion-segment-button value="b2b">{{ 'footer.property_owner' | translate }}</ion-segment-button>
              </ion-segment>
            </div>
            <div>
              <ion-input fill="outline" mode="md"
                         formControlName="email"
                         [placeholder]="'footer.email_placeholder' | translate">
              </ion-input>
              <ion-button mode="ios" type="submit" slot="end">{{ 'footer.subscribe' | translate }}</ion-button>
            </div>
          </div>
        </form>
      </ion-col>
      <ion-col size="12" size-lg="2.5" class="ion-hide-sm-down" [lang]="languageService.lang()" [dir]="languageService.dir()">
        <span class="h5">{{ 'footer.explore' | translate }}</span>
        <ul>
          @for (link of navigationContent?.navigationLinksFooter; track link) {
            <li><a [routerLink]="[link.link]">{{ link.text }}</a></li>
          }
        </ul>
      </ion-col>
      <ion-col size="12" size-lg="3.5" class="working-list">
        @defer (hydrate on interaction) {
          <span class="h5">{{ 'footer.working_hours' | translate }}</span>
          <ion-list lines="none" role="list">
            <ion-item role="listitem">
              <ion-icon slot="start" name="time-outline"></ion-icon>
              <ion-label>
                <p>{{pageContent()?.[languageService.lang()].openingHours}}</p>
              </ion-label>
            </ion-item>
            <ion-item role="listitem">
              <ion-icon slot="start" name="location-outline"></ion-icon>
              <ion-label>
                <p><a href="https://maps.app.goo.gl/mSKq8pzV4X37etp3A" aria-label="Satel | Properties in Riyadh" target="_blank">{{pageContent()?.[languageService.lang()].address}}</a></p>
              </ion-label>
            </ion-item>
            <ion-item role="listitem">
              <ion-icon slot="start" name="call-outline"></ion-icon>
              <ion-label>
                <p><a href="tel:{{pageContent()?.phoneNumber1}}">{{ pageContent()?.phoneNumber1 }}</a></p>
                <p><a href="tel:{{pageContent()?.phoneNumber2}}">{{ pageContent()?.phoneNumber2 }}</a></p>
              </ion-label>
            </ion-item>
            <ion-item role="listitem">
              <ion-icon slot="start" name="mail-outline"></ion-icon>
              <ion-label>
                <p><a href="mailto:{{pageContent()?.emailAddress}}">{{ pageContent()?.emailAddress }}</a></p>
              </ion-label>
            </ion-item>
        </ion-list>
        }

        <div class="ion-hide-sm-up ion-padding-top" style="margin-top: 24px">
          <span class="h5">{{ 'footer.explore' | translate }}</span>
          <ul>
            @for (link of navigationContent?.navigationLinksFooter; track link) {
              <li><a [routerLink]="[link.link]">{{ link.text }}</a></li>
            }
          </ul>
        </div>

        <div class="ion-hide-sm-up ion-padding-top" style="margin-top: 24px">
          <span class="h5">{{ 'footer.properties' | translate }}</span>
          <ul>
            <li><a [routerLink]="['/listings/filter']" [queryParams]="{sub: '66c34bc6acbf8133b5a99787'}">{{ 'footer.apartments' | translate }}</a></li>
            <li><a [routerLink]="['/listings/filter']" [queryParams]="{sub: '66c34badacbf8133b5a9977e'}">{{ 'footer.villas' | translate }}</a></li>
            <li><a [routerLink]="['/listings/filter']" [queryParams]="{sub: '66c969a89406c7dc60bd0ba5'}">{{ 'footer.compounds' | translate }}</a></li>
          </ul>
        </div>
      </ion-col>
      <ion-col size="12" size-lg="2">
        <div class="download-icons">
          <span class="h5">{{ 'footer.get_app' | translate }}</span>
          <div><a href="https://apps.apple.com/us/app/satel-tenants/id6738325133" target="_blank" aria-label="Download Satel app from Apple App Store"><ion-img src="assets/download_apple.webp" alt="Download from Apple App Store"></ion-img></a></div>
          <div><a href="https://play.google.com/store/apps/details?id=io.yarncloud.satel&pcampaignid=web_share" target="_blank" aria-label="Download Satel app from Google Play Store"><ion-img src="assets/download_android.webp" alt="Download from Google Play Store"></ion-img></a></div>
        </div>

<!--        <div class="text-align-right language ion-hide-sm-down">-->
<!--          <span class="h5">{{ 'footer.language' | translate }}</span>-->
<!--          <span class="_a" (click)="languageService.toggleLanguage()">-->
<!--            @if (languageService.lang() === 'en') {-->
<!--              <span dir="rtl" lang="ar">عربي</span>-->
<!--              <ion-img src="./assets/sa.webp" alt="ar"></ion-img>-->
<!--            } @else {-->
<!--              <ion-img src="./assets/gb.webp" alt="gb"></ion-img>-->
<!--              <span dir="ltr" lang="en">English</span>-->
<!--            }-->
<!--          </span>-->
<!--        </div>-->

        <div class="sm-links ion-hide-sm-up">
          @for (sm of smLinks; track sm) {
            <a [href]="sm?.link" aria-label="Satel | Properties in Riyadh" target="_blank"><ion-icon [name]="sm?.icon"></ion-icon></a>
          }
        </div>
      </ion-col>
    </ion-row>

    <div class="footer-end ion-text-center">
      <div class="terms">
<!--        <a [routerLink]="['/terms-and-conditions']">{{ 'footer.terms_of_use' | translate }}</a> | -->
        <a [routerLink]="['/cookies-policy']">{{ 'footer.privacy_policy' | translate }}</a>
      </div>
      <span>{{ 'footer.all_rights' | translate }} &copy; {{date | date: 'yyyy'}}</span>

      <div class="sm-links ion-hide-sm-down">
        @for (sm of smLinks; track sm) {
          <a [href]="sm?.link" aria-label="Satel | Properties in Riyadh" target="_blank"><ion-icon [name]="sm?.icon"></ion-icon></a>
        }
      </div>
    </div>
  </div>
</footer>
@defer (hydrate on viewport) {
  @if (showChat) {
    <ion-fab horizontal="end" vertical="bottom">
      <ion-fab-button color="success" [href]="'https://wa.me/' + pageContent()?.whatsAppNumber" target="_blank" aria-label="Contact via WhatsApp"><ion-icon name="logo-whatsapp"></ion-icon></ion-fab-button>
    </ion-fab>
  }
}

@if (hideCookies) {
  <div class="cookies-wrapper">
    <div class="cookies-content">
      <p>{{ 'footer.cookies_message' | translate }} <a [routerLink]="['/cookies-policy']">{{ 'footer.cookies_link' | translate }}</a></p>
      <ion-button expand="block" color="primary" (click)="acceptCookies()">{{ 'footer.accept' | translate }}</ion-button>
      <ion-button expand="block" color="dark" fill="outline" (click)="rejectCookies()">{{ 'footer.reject' | translate }}</ion-button>
    </div>
  </div>
}
